import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Home from "./Pages/Home";
import SingleEvent from "./Pages/SingleEvent";
import SingleModel from "./Pages/SingleModel";
import TopHeader from "./componets/TopHeader";
import Events from "./Pages/Events";
import Competitions from "./Pages/Competitions";
import SingleCompetition from "./Pages/SingleCompetition";
import RegisterScreen from "./Pages/RegisterScreen";
import { useEffect, useState } from "react";


function App() {

  const [loadPage, setLoadPage]           = useState(false);

  useEffect(() => {
    const handleDOMContentLoaded = () => {
      console.log("Ready");
      setTimeout(function () {
        setLoadPage(true);
      }, 5000);
    };
  
    if (document.readyState === 'loading') {
      // Document is still loading, listen for DOMContentLoaded event
      document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
    } else {
      // Document has already been loaded, run immediately
      handleDOMContentLoaded();
    }
  
    return () => {
      // Clean up the event listener if needed
      document.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
    };
  }, []);
  /*
  useEffect(() => {
    window.onload = () => {
      console.log("Readdy");
      setTimeout(function () {
        setLoadPage(true);
      }, 5000);  
    }
  },[])
  */

  return (
    <>
      <Router>
          <div className="main-container">
            <TopHeader />
            <Routes>
               <Route path="/" element={<Home />}/>  
               <Route path="/event/:id" element={<SingleEvent />}/>  
               <Route path="/modal/:id" element={<SingleModel />}/>  
               <Route path="/miss-south-africa" element={<Events /> } />
               <Route path="/competitions" element={<Competitions />} />
               <Route path="/competition/:id" element={<SingleCompetition />} />
               <Route path="/register" element={<RegisterScreen />} />
            </Routes>
          </div>
          <div className={`load-lay-start ${loadPage && 'slide-out'}`}>
             <div className="mid-welcome">
             <h2 className="welcome-title">Welcome To Votel</h2>
                  <svg viewbox="-10 -10 50 50 ">
                    <polygon points="30,0 0,32 32,32 0,0"></polygon>
                  </svg> 
             </div>               
          </div>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
